export default __webpack_public_path__ + "static/media/file.fc0f3a55.svg";